import { createSlice } from '@reduxjs/toolkit';

export const sendOmLetterSlice = createSlice({
  name: 'sendOmLetter',
  initialState: {
    loading: false,
    error: null,
    successMsg: null,
    reportEmails: ['yaguayo@happ.cl', 'caraya@happ.cl'],
    omLetterEmails: ['yaguayo@happ.cl', 'caraya@happ.cl'],
    reportFileName: null,
    omLetterFileName: null,
  },
  reducers: {
    initSendOmLetter: (state) => {
      state.loading = true;
    },
    setSuccessMessage: (state, action) => {
      state.loading = false;
      state.successMsg = action.payload;
    },
    setClearSuccessMessage: (state) => {
      state.successMsg = null;
    },
    sendOmLetterError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    sendReportConsentError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    cleanReportError: (state) => {
      state.error = null;
    },
    setReportEmails: (state, action) => {
      state.reportEmails = action.payload;
    },
    setOmLetterEmails: (state, action) => {
      state.omLetterEmails = action.payload;
    },
    setReportFileName: (state, action) => {
      state.reportFileName = action.payload;
    },
    setOmLetterFileName: (state, action) => {
      state.omLetterFileName = action.payload;
    },
    clearReportFileName: (state) => {
      state.reportFileName = null;
    },
    clearOmLetterFileName: (state) => {
      state.omLetterFileName = null;
    },
  },
});

export const {
  initSendOmLetter,
  setSuccessMessage,
  sendOmLetterError,
  cleanReportError,
  setReportEmails,
  setOmLetterEmails,
  sendReportConsentError,
  setReportFileName,
  setOmLetterFileName,
  setClearSuccessMessage,
  clearReportFileName,
  clearOmLetterFileName,
} = sendOmLetterSlice.actions;